<template>
    <div class="g pop-up-inner">
        <mdToggleAside
            :showBtn="false"
        ></mdToggleAside>
        <mdCaption
            :caption="$t('popup.signin.caption.signinalert')"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="g">
                    <div class="fieldset">
                        <label>{{ $t('site.noun.userid') }}</label>
                        <div class="cp input text" disabled>
                            <input :value="user.accountid" type="text" disabled>
                        </div>
                    </div>
                    <div class="fieldset">
                        <label>{{ $t('site.noun.password') }}</label>
                        <div class="cp input password" :class="[errors.has('password')? 'is-error': '']" :data-error="errors.first('password')">
                            <input v-model="password" type="password" v-validate="'required'" name="password" id="password">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </div>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'

    import { mapState, mapActions, mapMutations } from 'vuex'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: { //依照模板定義
                require: false,
                default: () => {
                    return {}
                }
            }
        },
        data: function(){

            return {
                password: '',
            }
        },
        computed: {
            ...mapState([
                'user',
            ]),
            btns: function(){

                let $login = {
                        text: this.$t('site.func.login'),
                        themes: 'major',
                        func: 'login',
                    },
                    $logout = {
                        text: this.$t('site.func.logout'),
                        func: 'logoutFunc',
                    }

                return [
                    $login,
                    $logout,
                ]
            },
        },
        methods: {
            ...mapActions([
                'getAuth'
            ]),
            ...mapMutations([
                'logout',
            ]),
            logoutFunc: function(_key){

                this.logout(() => {
                    this.$router.push('/index');
                    this.close();
                });
            },
            login: function(){

                this.$validator.validate().then(result => {
                    if (!result){
                        //啊就沒通過啊
                    }else {

                        this.getAuth({
                            account: this.user.accountid,
                            password: this.password,
                            callback: this.close
                        });
                    }
                });
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            }
        }
    }
</script>

<style scoped lang="scss">

    .fieldset {
        padding: $interval-xs 0;

        label {
            display: block;
            margin-bottom: $interval-s;
        }
    }
</style>
